export default function (title: string) {
  const newTitle = title.replace(' | Hoxton Mix | Hoxton Mix', ' | Hoxton Mix')
  if (newTitle.length > 70) {
    return newTitle.replace(' | Hoxton Mix', ' | HM')
  }
  return newTitle
}
